import {
  Box,
  styled,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { ArrowLeft, ArrowRight } from 'iconsax-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { useConfig } from '../../../Hooks/useConfig';
import BaseButton from '../../../components/common/BaseButton';
const HomeServicesContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.primary.main,
}));
const HomeservicesBox = styled(Box)(({ theme, mdDown }) => ({
  padding: mdDown ? '17px' : '33px 25px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.mode === 'dark' ? '#262626' : '#FFFFFF',
  borderRadius: '16px',
  transition: 'all .2s ease-in-out',
  border: `1px solid ${theme.palette.mode === 'dark' ? '#8CCFF9' : '#8ccff9'}`,
  height: '100%',
  minHeight: mdDown ? 'auto' : '276px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? '#464646' : '#e1f2fd',
    borderColor: theme.palette.mode === 'dark' ? '#70C4F7' : '#0486D7',
    boxShadow: `0px 2px 8px ${theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0.25)'}`,
    '& .default-icon': {
      opacity: 0,
    },
    '& .hover-icon': {
      opacity: 1,
    },
  },
}));

const HomeServicesContentSoon = styled(Box)(({ theme, mdDown }) => ({
  padding: mdDown ? '17px' : '33px 25px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.mode === 'dark' ? '#1A1A1A' : '#F5F5F5',
  borderRadius: '16px',
  border: `1px solid ${theme.palette.mode === 'dark' ? '#333' : '#E5E5E5'}`,
  height: '100%',
  minHeight: mdDown ? 'auto' : '276px',
  opacity: 0.7,
}));

const HomeServicesImg = styled(Box)(({ theme, mdDown }) => ({
  width: '48px',
  height: '48px',
  borderRadius: '12px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.mode === 'dark' ? '#2A2A2A' : '#F5F5F5',
  marginBottom: mdDown ? '0' : '24px',
  position: 'relative',
  flexShrink: 0,
  img: {
    width: '48px',
    transition: 'opacity .2s ease-in-out',
  },
  '.hover-icon': {
    position: 'absolute',
    opacity: 0,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '48px',
  },
}));

const ServiceTitle = styled(Typography)(({ theme, mdDown }) => ({
  fontFamily: 'Poppins, sans-serif',
  fontSize: mdDown ? '16px' : '18px',
  fontWeight: 500,
  color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#1A1B1F',
  marginBottom: mdDown ? '0' : '12px',
  lineHeight: 'normal',
}));

const HomeServicesDescription = styled(Typography)(({ theme, mdDown }) => ({
  fontFamily: 'Poppins, sans-serif',
  fontSize: '12px',
  fontWeight: 400,
  color: theme.palette.mode === 'dark' ? '#A5A5A5' : '#787878',
  marginBottom: mdDown ? '16px' : '24px',
  lineHeight: '1.5',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
}));

const HomeServices = ({ service }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const link = '/' + service?.playground_link?.split('/').pop();

  const renderContent = () => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: mdDown ? '16px' : 0,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: mdDown ? 'row' : 'column',
          alignItems: mdDown ? 'center' : 'flex-start',
          gap: mdDown ? '8px' : 0,
        }}
      >
        <HomeServicesImg mdDown={mdDown}>
          <img
            alt={service.text}
            className="default-icon"
            src={`/static/img/icon/services-icon/${theme.palette.mode === 'dark' ? service.icon_url_dark : service.icon_url_light}`}
          />
          {!service.comingSoon && (
            <img
              alt={service.text}
              className="hover-icon"
              src={`/static/img/icon/services-icon/${theme.palette.mode === 'dark' ? service.icon_hover_url_dark : service.icon_hover_url_light}`}
            />
          )}
        </HomeServicesImg>
        <ServiceTitle mdDown={mdDown}>
          {t(`services.${service.key}`)}
        </ServiceTitle>
      </Box>
      <HomeServicesDescription mdDown={mdDown}>
        {service.description}
      </HomeServicesDescription>
    </Box>
  );

  return (
    <>
      {service.comingSoon ? (
        <HomeServicesContentSoon mdDown={mdDown}>
          <Box>{renderContent()}</Box>
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 700,
              color: '#A5A5A5',
              textTransform: 'uppercase',
            }}
          >
            Coming Soon
          </Typography>
        </HomeServicesContentSoon>
      ) : (
        <Link to={link} style={{ textDecoration: 'none' }}>
          <HomeservicesBox className="hover-trigger" mdDown={mdDown}>
            {renderContent()}
            <BaseButton
              component="div"
              size="small"
              width="full"
              sx={{
                fontWeight: 600,
                fontSize: '14px',
                borderRadius: '8px',
              }}
            >
              {t('global.try_it_now')}
            </BaseButton>
          </HomeservicesBox>
        </Link>
      )}
    </>
  );
};
export default HomeServices;
